import { Controller } from "@hotwired/stimulus";
import * as echarts from "echarts";

export default class extends Controller {
  static values = {
    url: String,
    legendHeight: { type: Number, default: 60 }
  };

  connect() {
    this.chart = echarts.init(this.element);

    this.chart.showLoading("default", {
      text: "Загрузка данных...",
      color: "#ed8936",
      textColor: "#334155",
      maskColor: "rgba(255, 255, 255, 0.8)",
      zlevel: 0
    });

    fetch(this.urlValue)
      .then((response) => {
        if (!response.ok) throw new Error(`Ошибка получения данных: ${response.status}`);
        return response.json();
      })
      .then((json) => {
        this.chart.hideLoading();

        const baseOptions = {
          grid: { containLabel: true }
        };

        this.chart.setOption(baseOptions);
        this.chart.setOption(json);

        this.initClickActions();
        this.initResizeObserver();
      })
      .catch((err) => console.error(`Ошибка запроса: ${err.message}`));
  }

  initClickActions() {
    if (!this.chart) return;

    this.chart.on("click", (params) => {
      if (params.seriesName === "Решилось задач за прошлую неделю") {
        const data = params.data;
        const box = document.getElementById("details-box");
        const title = document.getElementById("detail-title");
        const value = document.getElementById("detail-value");
        const list = document.getElementById("detail-list");

        if (!box || !title || !value || !list) return;

        box.style.display = "block";

        title.innerText = `${params.seriesName} на ${params.name}`;
        value.innerHTML = `Всего: <strong>${params.value}</strong>`;

        if (data.list && Array.isArray(data.list)) {
          list.innerHTML = data.list
            .map(item => `<div class="w-40"><a target="_blank" href="/entries/${item}">${item}</a></div>`)
            .join("");
        }

        box.scrollIntoView({ behavior: "smooth" });
      }
    });
  }

  initResizeObserver() {
    if (typeof ResizeObserver === "undefined" || !this.chart) return;
    this.resizeObserver = new ResizeObserver(() => {
      if (this.chart) this.chart.resize();
    });
    this.resizeObserver.observe(this.element);
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.chart) {
      this.chart.off("click");
      this.chart.dispose();
      this.chart = null;
    }
  }
}
